<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <relatorios-data-table :items="items" :loading="loading" @rechargeTable="getRelatoriosModelos()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import RelatoriosModelosService from '@/services/RelatoriosModelosService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    components: {
      RelatoriosDataTable: () => import('@/components/power-ups/relatorios-modelos/RelatoriosDataTable')
    },
    mixins: [refreshDataMixins],

    data: () => ({
      items: [],
      loading: false
    }),

    mounted() {
      this.refreshData(this.getRelatoriosModelos);
    },

    methods: {
      getRelatoriosModelos() {
        this.items = [];
        this.loading = true;
        RelatoriosModelosService.index()
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
